<template lang="pug">
  v-app.axisfc
    global-header
    v-main#content
      v-container
        .breadcrumb.d-none.d-sm-block.mb-3.mt-2
          a(href='/') HOME
          span.mx-1 &gt;
          span 説明会のご予約
        h1.pagetitle
          span 説明会のご予約
        v-row.no-gutters.pt-3(role="tablist" tag="nav")
          v-col.text-center.tab.pr-1
            router-link.d-block.py-3.py-sm-6.rounded(to='/venues' role="tab")
              v-icon.mr-0.mr-sm-2.mb-1.mb-sm-0 mdi-map-marker
              .d-sm-inline.d-block 会場を選ぶ
            v-icon.selected-marker(large) mdi-menu-down
          v-col.text-center.tab.pl-1
            router-link.d-block.py-3.py-sm-6.rounded(to='/online' role="tab")
              v-icon.mr-0.mr-sm-2.mb-1.mb-sm-0 mdi-laptop
              .d-sm-inline.d-block オンライン説明会
            v-icon.selected-marker(large) mdi-menu-down
        transition(name="fade")
          keep-alive
            router-view
    v-container
      .breadcrumb
        a(href='/') HOME
        span.mx-1 &gt;
        span 説明会のご予約
    global-footer
</template>

<style lang="scss">
.v-application.axisfc {
  font-family: "メイリオ","Meiryo","ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro","ＭＳ Ｐゴシック","MS PGothic",Sans-Serif;
  line-height: 1.8;
  text-rendering: auto;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-feature-settings: "palt" 1;

  .breadcrumb {
    font-size: 11px;
  }

  a {
    text-decoration: none;
  }

  .sp-only {
    @media screen and (min-width: 480.02px) {
      display: none !important;
    }
  }

  .body-1 {
    @media screen and (max-width: 480px) {
      font-size: 14px !important;
    }
  }

  .pagetitle {
    font-size: 30px;
    font-family: 'UD Shin Go Medium', sans-serif;
    width: 100%;
    height: auto;
    padding: 0.75em;
    padding-left: 1em;
    padding-right: 0;
    background: linear-gradient(to right, transparent 8px,#f5f9fe 8px,#f5f9fe 100%), linear-gradient(to bottom, #555fa1 0%,#555fa1 49%,#2a378a 50%,#2a378a 100%);
    border: 1px solid #d9dfeb;
    display: flex;
    flex-direction: row;
    align-items: center;

    @media screen and (max-width: 480px) {
      font-size: 18px;
      margin-bottom: 0.5em;
    }

    span {
      display: inline-block;
      transform: rotate(0.05deg);
    }

    em {
      display: inline-block;
      transform: rotate(0.05deg);
      font-style: normal;
      font-size: 0.6em;
      color: rgb(211, 46, 46);

      span {
        line-height: 1;
        font-size: 0.85em;
        padding: 0.3em 0.2em;
        border-radius: 0.25em;
        margin-left: 1em;
        margin-right: 0.5em;
        color: #f5f9fe;
        background-color: rgb(211, 46, 46);
      }
    }
  }

  nav[role=tablist] {
    [role=tab] {
      background-image: linear-gradient(to bottom, #f5f9fe 0%,#f5f9fe 49%,#f5f9fe 50%,#f5f9fe 100%);
      border: 1px solid #d9dfeb;
      color: #2a378a;
      font-family: "UD Shin Go Medium";
      font-size: 1.5em;

      @media screen and (max-width: 480px) {
        font-size: 1.2em;
      }

      &:hover, &.router-link-active {
        color: white;
        background-image: linear-gradient(to bottom, #555fa1 0%,#2a378a 50%);

        &:hover:not(.router-link-active) {
          opacity: 0.75;
        }

        .v-icon {
          border-color: white;
          background-color: white;
        }
      }

      .v-icon {
        color: #2a378a;
        border-style: solid;
        border-width: 2px;
        padding: 0.2em;
        border-radius: 1em;
        border-color: #2a378a;
      }
    }

    .selected-marker {
      display: none;
      color: #2a378a;
    }

    .router-link-active + .selected-marker {
      display: inline-block;
    }
  }

  main {
    @media screen and (min-width: 480.2px) {
      font-size: 16px;
    }
    @media screen and (max-width: 480px) {
      font-size: 14px;
    }
  }

  @media (min-width: 480.2px) {
    .container {
      width: 1004px;
      max-width: 1004px;
    }
  }

  .router-view-container {
    @media screen and (min-width: 480.2px) {
      border: 2px solid #f8f8f8;
      background-image: repeating-linear-gradient(-45deg, white, white 5px, #f8f8f8 5px, #f8f8f8 10px);
      padding: 2em;
    }
    @media screen and (max-width: 480px) {
      font-size: 14px;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: all .35s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(10px)
  }

  .fade-leave-active, .fade-leave-to {
    display: none
  }
}

</style>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue'
import GlobalFooter from '@/components/GlobalFooter.vue'
import $ from "jquery"


export default {
  name: 'App',
  components: {
    GlobalHeader,
    GlobalFooter,
  },
  data: () => ({
    //
  }),
  mounted: function () {
    $('img.rover, input.rover, .all-rover img').hover(
      function() { //enter
          $(this).attr('src', $(this).attr('src').replace(/(\.[a-zA-Z]{3})$/, '_on$1'))
      },
      function() { //leave
          $(this).attr('src', $(this).attr('src').replace(/_on\./, '.'))
      } 
    )
  },
  methods: {
    // sleep 処理
    sleep (msec) {
      new Promise(resolve => setTimeout(resolve, msec));
    }
  }
};
</script>
